export default __webpack_public_path__ + "static/media/sprite.85ce2a53.svg";